import {Component, inject, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {FormsModule, NgForm} from '@angular/forms';
import {PasswordValidationDirective} from '../../../validation/directives/password-validation-directive';
import {Subscription} from 'rxjs';
import {AuthService} from '../../../services/auth-service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-login-component',
  imports: [
    FormsModule,
    RouterLink,
    PasswordValidationDirective
  ],
  templateUrl: './login-component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './login-component.scss'
})
export class LoginComponent implements OnDestroy {

  subscription: Subscription | null = null;
  error: string | undefined;

  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);

  constructor() {
    this.authService.isAuthenticated()
      .pipe(
        takeUntilDestroyed()
      )
      .subscribe(result => {
        if (result) {
          this.router.navigate(['/main']);
        }
      });
  }



  login(form: NgForm) {
    this.error = undefined;
    if (form.valid) {
      this.subscription = this.authService.login(form.value.email, form.value.password)
        .subscribe(result => {
          if (result.data) {
            this.router.navigate(['/main']);
          } else {
            this.error = result.error;
          }
        })
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
